export default __webpack_public_path__ + "static/instagram-33929911a8c6d94b748856cf074d7ebe.png";